var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vuestic-color-square",style:({'background-color': _vm.value})})
}
var staticRenderFns = []

export { render, staticRenderFns }